/*
 * Utility to wrap sessionStorage and dispatch events on changes
 * React hook to subscribe to sessionStorage changes for a key
 */
import { useEffect, useState } from 'react'

export const SESSION_STORAGE_EVENT = 'session-storage-change'

export function setSessionStorageItem(key: string, value: string) {
  sessionStorage.setItem(key, value)
  window.dispatchEvent(
    new CustomEvent(SESSION_STORAGE_EVENT, { detail: { key, value } })
  )
}

export function removeSessionStorageItem(key: string) {
  sessionStorage.removeItem(key)
  window.dispatchEvent(
    new CustomEvent(SESSION_STORAGE_EVENT, { detail: { key, value: null } })
  )
}

export function getSessionStorageItem(key: string): string | null {
  return sessionStorage.getItem(key)
}

export function useSessionStorageValue(key: string) {
  const [value, setValue] = useState<string | null>(() =>
    getSessionStorageItem(key)
  )

  useEffect(() => {
    const handler = (event: Event) => {
      const customEvent = event as CustomEvent
      if (customEvent.detail?.key === key) {
        setValue(customEvent.detail.value)
      }
    }
    window.addEventListener(SESSION_STORAGE_EVENT, handler)
    return () => window.removeEventListener(SESSION_STORAGE_EVENT, handler)
  }, [key])

  return value
}
